import { MonsterChartProps } from '@procureai/ui-mui';

interface SpendAnalysisSegment {
  key: string;
  data: number[];
}
interface SpendAnalysis {
  id: string;
  title: string;
  labels: string[];
  segments: SpendAnalysisSegment[];
}
interface MergeDataSourcesResult {
  data: any[];
  dataConfig: MonsterChartProps['dataConfig'];
}

export const mergeDataSources = (
  left: SpendAnalysis | null | undefined,
  right: SpendAnalysis | null | undefined,
): MergeDataSourcesResult => {
  const result: any = {
    data: [],
    dataConfig: {
      lines: [],
      bars: [],
    },
  };

  const main = right || left;

  if (main) {
    let i = 0;
    const m = main.segments.length;

    while (i < m) {
      const item: any = {};
      if (left) {
        item.key = left.segments[i].key;
        left.segments[i].data.forEach((d, i) => {
          item[`bar${i}`] = d;
        });
      }
      if (right) {
        item.key = right.segments[i].key;
        right.segments[i].data.forEach((d, i) => {
          item[`line${i}`] = d;
        });
      }
      result.data.push(item);
      ++i;
    }

    if (left) {
      result.dataConfig.bars = left.labels.map((label, index) => ({
        label,
        dataKey: `bar${index}`,
      }));
    }
    if (right) {
      result.dataConfig.lines = right.labels.map((label, index) => ({
        label,
        dataKey: `line${index}`,
      }));
    }
  }

  return result;
};
